import React from "react";
import styled from "styled-components";
import {
  useBuffered,
  useCurrentTime,
  useDuration,
} from "./hooks/useCurrentTime";

const StatusBar = ({
  videoElement,
  src,
}: {
  videoElement: HTMLVideoElement | null;
  src: string;
}) => {
  const currentTime = useCurrentTime(videoElement);
  const duration = useDuration(videoElement);
  const percentage = 100 * (currentTime / duration);

  const buffered = useBuffered(videoElement);

  const extension = src.split(".").at(-1);
  return (
    <StatusBarWraper>
      <Title>stakra</Title>
      <Time>{`${Math.floor(currentTime)}/${duration}`}</Time>
      <TimeRange>
        <Playhead percentage={percentage} />
        {buffered && <Buffered buffered={buffered} duration={duration} />}
      </TimeRange>
      <Extension>{extension}</Extension>
    </StatusBarWraper>
  );
};

const Title = styled.div`
  color: rgb(180, 210, 115);
  height: 100%;
  padding: 4px 8px 6px 0;
  vertical-align: center;
  box-sizing: border-box;
  text-align: center;
  border-right: solid 0.5px rgb(180, 210, 115);
  font-family: Faustina;
  font-size: 20px;
  line-height: 24px;
  transition: color 1s ease-in-out;

  &:hover {
    color: rgba(255, 255, 255, 1);
  }
`;

const StatusBarWraper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  background: rgb(21, 21, 21);
  height: 40px;
  border-bottom: solid 0.5px rgb(180, 210, 115);
  border-top: solid 0.5px rgb(180, 210, 115);
  padding: 0 8px;
  max-width: 100vw;
`;

const Time = styled.div`
  vertical-align: center;
  color: rgb(180, 210, 115);
  font-family: "Source Code Pro", monospace;
  font-size: 18px;
  line-height: 22px;
  width: 120px;
  margin: 4px;
`;

const Extension = styled.div`
  vertical-align: center;
  color: rgb(180, 210, 115);
  font-family: "Source Code Pro", monospace;
  font-size: 18px;
  line-height: 22px;
  margin: 4px;
`;

const TimeRange = styled.div`
  position: relative;
  width: 50%;
  height: 22px;
  border: 0.2px solid rgb(180, 210, 115);
`;

const Playhead = styled.div<{ percentage: number }>`
  position: relative;
  width: ${(props) => props.percentage}%;
  background: rgb(180, 210, 115);
  height: 100%;
  z-index: 100;
`;

export default StatusBar;

const Buffered = ({
  buffered,
  duration,
}: {
  buffered: TimeRanges;
  duration: number;
}) => {
  const timeRanges = [];
  for (let i = 0; i < buffered.length; i++) {
    timeRanges.push({
      start: buffered.start(i),
      end: buffered.end(i),
    });
  }

  return (
    <div
      style={{ position: "absolute", height: "100%", width: "100%", top: 0 }}
    >
      {timeRanges.map((range) => (
        <RangeBox
          start={(100 * range.start) / duration}
          width={(100 * (range.end - range.start)) / duration}
        ></RangeBox>
      ))}
    </div>
  );
};

const RangeBox = styled.div<{ start: number; width: number }>`
  position: absolute;
  left: ${(props) => props.start}%;
  width: ${(props) => props.width}%;
  height: 100%;
  background: #444;
`;
